import {
  ZipFileStatus,
  asyncTaskToPDFGenerationStatusMap,
} from 'src/components/selfService/features/OrderHistory/ZipDownload/ZipDownload.utils';
import { useAsyncDownloadTask } from 'src/utilities/useAsyncDownloadTask/useAsyncDownloadTask';
import { startBulkPdfGeneration } from './OrderReceiptsZipApi';

export interface UseGenerateZipFile {
  generateZipFile: () => void;
  downloadUrl: string;
  status: ZipFileStatus;
}

export interface UseGeneratePdfFileProps {
  corpId: string;
  dinerId?: string;
  dateFrom: string;
  dateTo: string;
  query?: string;
}

export const useGenerateZipFile = ({
  corpId,
  dinerId,
  dateFrom,
  dateTo,
  query,
}: UseGeneratePdfFileProps): UseGenerateZipFile => {
  const {
    status: asyncTaskStatus,
    startAsyncTask,
    downloadUrl,
  } = useAsyncDownloadTask();

  async function generateZipFile() {
    await startAsyncTask(() =>
      startBulkPdfGeneration({
        corpId,
        dinerId,
        dateFrom,
        dateTo,
        query,
      })
    );
  }

  return {
    generateZipFile,
    downloadUrl,
    status: asyncTaskToPDFGenerationStatusMap.get(asyncTaskStatus),
  };
};
